// d1-tokens.js — shared editorial design tokens.
//
// Extracted from D1Page so D1WhyFlashFluency and D1Pricing can import the
// same tokens without creating a circular dependency. D1Page imports from
// here too; everything stays consistent.

export const D1 = {
  bg:       '#141110',
  bg2:      '#1c1816',
  ink:      '#f5efe6',
  dim:      '#9a908a',
  faint:    '#5a524d',
  rule:     'rgba(245,239,230,0.08)',
  orange:     '#ff8a3d',
  orangeDeep: '#e06a1f',
  serif: "'Fraunces', 'Tiempos Headline', 'Playfair Display', Georgia, serif",
  sans:  "'Inter', -apple-system, 'Segoe UI', sans-serif",
  mono:  "'JetBrains Mono', 'IBM Plex Mono', ui-monospace, monospace",
  ko:    "'Noto Serif KR', 'Apple SD Gothic Neo', serif",
};

export const STORE_URLS = {
  appStore:   'https://apps.apple.com/us/app/flashfluency-korean/id6757165176',
  googlePlay: 'https://play.google.com/store/apps/details?id=net.flashfluency.app&hl=en_US',
};

export const SOCIAL = {
  discord:   'https://discord.gg/rtqrugEEQh',
  instagram: 'https://instagram.com/flashfluencykorean',
  tiktok:    'https://tiktok.com/@flashfluencykorean',
};

export const BETA_END_DATE = new Date('2026-05-15T23:59:59');
export const isBeta = () => new Date() < BETA_END_DATE;

export const FF_ENV  = process.env.REACT_APP_FF_ENV || 'prod';
export const APP_URL = FF_ENV === 'prod'
  ? 'https://app.flashfluency.net'
  : 'https://app-test.flashfluency.net';